
import {
  addGoodsFile,
  getGoodsFileDtl,
  getGoodsUnitList,
  getIngredientCategory,
  getIngredientCategoryList,
  getOfflineCategoryList,
  updateGoodsFile,
  getDataByBarcode,
  getIngredientList,
  getPluCode
} from "@/api/ccxIntegratedService";
import { getCompanyCode } from "@/api/customerManage";
import { sftpChooseFile } from "@/utils/h5ToApp";
import { imagePreview } from "@/utils/util";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import draggable from 'vuedraggable'

Component.registerHooks(["beforeRouteEnter"]);
@Component({
  components: {
    draggable
  }
})
export default class AddGoods extends Vue {
  @Getter companyId!: string;
  // @Getter topSafetyHeight!: number

  imagePreview = imagePreview;
  sftpUrl = "";
  type = "add";
  form: any = {
    ingredientId: "",
    goodsName: "",
    barcode: "",
    memoryCode: "",
    specification: "",
    brand: "",
    productType: "",
    productTypeName: "",
    sellUnitWay: "",
    unitId: "",
    isOfflineProduct: 0,
    offlineCategoryId: "",
    offlineCategoryName: "",
    offlinePrice: "",
    isStoreProduct: 0,
    categoryId: "",
    categoryName: "",
    salesTitle: "",
    sellUnit: "",
    price: "",
    storeImageList: [],
    costPrice: "",
    offlineProfitMargin: "",
    profitMargin: "",
    isSettingPlu: 0,
    pluCode: '',
    isItem: 0 , // 1显示为份
    unitChange: false, // 显示为份 单选框控制
    isNextDayDelivery: false, // 是否开启次日达
    isPresaleJoin:false, // 是否开启预售接龙
    joinMargin:'',
    joinPrice:'', // 接龙专属价格
    joinSellUnit: '', // 接龙规格起售数量
    joinIsItem: 0, // 接龙 1显示为份
    joinunitChange: false, // 接龙 显示为份 单选框控制
    joinSellUnitWay: '' , // 接龙单位
  };
  goodsUnitList = [];
  showUnit = false;
  showGoodsType = false;
  showCategoryPicker = false;
  goodsId = "";
  defaultGoodsTypeIndex = 0;
  defaultUnitIndex = 0;
  fromType = '' // 1 扫码进入  2 输入名称进入
  noData = true
  ingredientList = []

  productTypeList = [
    { id: 1, name: "计件商品" },
    { id: 2, name: "计重商品" },
  ];

  showStoreCategoryPicker = false;
  columns = [];
  activeStoreCategoryId = "";
  mainActiveIndex = 0;

  columnsCategory = [];
  fieldError = '请点选本商品对应的食材'
  showIngredientError = false
  loadingIngredient = false

  showsellWayError = false
  submitting = false


  // 监听ingredientId变化，判断是否显示错误提示
  @Watch('form.ingredientId', { immediate: true })
  showTips() {
    if (this.form.ingredientId){
      this.showIngredientError = false
      this.getIngredientCategoryFn();
    }
    this.$forceUpdate()
  }

  // 监听勾选的微店销售方式变化
  @Watch('form.isNextDayDelivery', { immediate: true })
  showError1() {
    if (!this.form.isNextDayDelivery || !this.form.isPresaleJoin){
      this.showsellWayError = false
    }
    this.onPurchase() // 勾选状态变更，重算毛利率
    this.$forceUpdate()
  }

  @Watch('form.isPresaleJoin', { immediate: true })
  showError2() {
    if (!this.form.isPresaleJoin || !this.form.isNextDayDelivery){
      this.showsellWayError = false
    }
    this.onPurchase() // 勾选状态变更，重算毛利率
    this.$forceUpdate()
  }

  // 监听isStoreProduct变化，添加为微店商品开关首次打开时，将销售标题填充为商品名称
  @Watch('form.isStoreProduct', { immediate: true })
  setSalesTitle() {
    this.form.salesTitle = this.form.salesTitle ? this.form.salesTitle : this.form.goodsName
    this.$forceUpdate()
  }

  changeGoodsName () {
    if(this.form.goodsName.trim()) {
      this.searchIngredientList()
      // this.getCompanyCodeFn()
    } else {
      this.ingredientList = []
      this.form.ingredientId = ''
      this.form.memoryCode = ''
    }
  }

  async searchIngredientList() {
    if(this.form.goodsName && !this.ingredientList.length) this.loadingIngredient = true
    if (!this.form.goodsName.trim()) {
      this.ingredientList = [];
      return;
    }

    try {
      // 调用真实的API接口获取建议数据
      const { data } = await getIngredientList({
        goodsName: this.form.goodsName,
        storeId: this.companyId,
      });
      this.ingredientList = data;
      this.ingredientList.push({
        ingredientId: 'mismatch',
        ingredientName: '匹配不准确'
      })
      this.loadingIngredient = false
    } catch (error) {
      this.ingredientList = [];
      this.loadingIngredient = false
    }
  }

  // 获取Plu
  getPlu () {
    getPluCode({ storeId: this.companyId }).then((res: any) => {
      this.form.pluCode = res.data.pluCode
      this.$forceUpdate()
    })
  }

  changePLU (e: any) {
    this.form.pluCode = e.target._value
  }

  onCheckUnitChange (e:any, type:number) {
    console.log('e----------', e)
    if (type === 1) {
      this.form.unitChange = e
      this.form.isItem = e ? 1 : 0
      this.$forceUpdate()
    } else {
      this.form.joinunitChange = e
      this.form.joinIsItem = e ? 1 : 0
      this.$forceUpdate()
    }
  }

   /**
   * 进货价 / 线下毛利率 / 次日达毛利率 三者的互算
   * @param {number} costPrice - 进货价
   * @param {number} offlinePrice - 零售价
   * @param {string} offlineProfitMargin - 线下毛利率（0.25 表示 25%）
   * @param {string} price - 微店价
   * @param {string} profitMargin - 次日达毛利率
   * @returns {number} - 运算结果。
   */
  keep2(v: any) {
    return Math.round(v * 100) / 100
  }

   /**
   * 通用毛利率计算 公式：(售价 - 进货价 * 规格值) / 售价 * 100%
   */
  calcMarginRate(sellPrice: number | string, costPrice: number | string, specVal: number | string) {
    const price = Number(sellPrice)
    const cost = Number(costPrice)
    const spec = Number(specVal)
    if (!price || !cost || !spec) return ''
    const rate = (price - cost * spec) / price * 100
    return this.keep2(rate)
  }

   /**
   * 正向计算所有毛利率（唯一计算入口）
   * 触发时机：进货价/零售价/次日达售价/规格值 失焦修改时执行
   */
  onPurchase() {
    const form = {...this.form}
    // 进货价为空，清空全部毛利率
    if (!form.costPrice) {
      form.offlineProfitMargin = ''
      form.profitMargin = ''
      form.joinMargin = ''
      this.form = form
      return
    }
    form.costPrice = this.keep2(Number(form.costPrice))

    // 1. 线下毛利率
    if (form.offlinePrice && Number(form.offlinePrice) > 0) {
      form.offlineProfitMargin = this.keep2((1 - Number(form.costPrice) / Number(form.offlinePrice)) * 100)
    } else {
      form.offlineProfitMargin = ''
    }

    // 2. 次日达毛利率（新规格公式，勾选次日达才计算）
    if (form.isNextDayDelivery && form.price && form.sellUnit && Number(form.price) > 0) {
      form.profitMargin = this.calcMarginRate(form.price, form.costPrice, form.sellUnit)
    } else {
      form.profitMargin = ''
    }

    // 3. 接龙毛利率（新规格公式，勾选接龙才计算）
    if (form.isPresaleJoin && form.joinPrice && form.joinSellUnit && Number(form.joinPrice) > 0) {
      form.joinMargin = this.calcMarginRate(form.joinPrice, form.costPrice, form.joinSellUnit)
    } else {
      form.joinMargin = ''
    }

    this.form = form
  }

  async created() {
    this.sftpUrl = this.$store.state.user.sftpUrl;
    await Promise.all([
      this.getGoodsUnitListFn(),
      this.getOfflineCategoryListFn(),
      this.getIngredientCategoryListFn(),
    ]);
    this.type = (this.$route.query.type as string) || "add";
    if (this.type === "edit") {
      this.goodsId = (this.$route.query.goodsId as string) || "";
      this.getGoodsFileDtlFn();
    } else {
      // 从路由参数获取商品名称
      this.form.goodsName = (this.$route.query.ingredientName as string) || "";
      this.form.barcode = (this.$route.query.barcode as string) || "";
      this.form.ingredientId = (this.$route.query.ingredientId as string) || "";
      this.fromType = (this.$route.query.fromType as string)
      // 有条形码 则根据条形码获取商品信息
      if(this.$route.query.barcode && this.$route.query.barcode !== "") await this.getDataByBarcodeData()
      // 有商品名称 则根据商品名称搜索商品库
      if(this.$route.query.ingredientName && this.$route.query.ingredientName !== "") await this.searchIngredientList()
      // this.getCompanyCodeFn();
    }
    if (!this.form.ingredientId) return;
    this.getIngredientCategoryFn();
  }

  // 根据条码获取数据
  async getDataByBarcodeData() {
    const { data } = await getDataByBarcode({
      barcode: (this.$route.query.barcode as string)
    });
    if (data) {
      this.form = {
        ...this.form,
        ...data,
      }
      this.noData = data.goodsName ? false : true
      this.defaultGoodsTypeIndex = this.productTypeList.findIndex(
        (i) => i.id === data.productType
      );
      this.form.productTypeName = this.productTypeList[this.defaultGoodsTypeIndex].name;
      setTimeout(() => {
        this.searchIngredientList()
      }, 500)
    } else {
      this.noData = true
    }
  }

  onCancel() {
    this.$router.go(-1);
  }

  get isFromSelectGoods (): boolean {
    return this.$route.query.from === "selectGoods";
  }

  /** 保存完成后返回：接龙选品页刷新；新增经关联页需 go(-2)，编辑仅 go(-1) */
  private navigateAfterFinish (): void {
    if (this.isFromSelectGoods) {
      window.sessionStorage.setItem("jielongSelectGoodsRefresh", "1");
      this.$router.go(this.type === "edit" ? -1 : -2);
      return;
    }
    this.$router.go(-1);
  }

  switchover() {
    if (this.type === "add") {
      this.$router.go(-1);
    } else {
      this.$router.push("/addGoodsAssociate");
    }
  }
  onConfirm() {
    if (this.submitting) return
    if (!this.form.ingredientId) {
      this.showIngredientError = true
    }
    if (Boolean(this.form.isStoreProduct) && !this.form.isPresaleJoin && !this.form.isNextDayDelivery) {
      this.showsellWayError = true
      return
    }
    (this.$refs.formRef as any)
      .validate()
      .then(async () => {
        const params = {
          storeId: this.companyId,
          ...this.form,
        };
        
        if (!this.form.ingredientId) {
          params.ingredientId = "mismatch";
        }
        console.log(params, "=====params");
        // 说明未点选食材库匹配的食材
        if (this.showIngredientError) return
        this.submitting = true
        try {
          if (this.type === "add") {
            await addGoodsFile(params);
            this.$toast.success("新增成功");
          } else {
            await updateGoodsFile(params);
            this.$toast.success("编辑成功");
          }
          this.navigateAfterFinish();
        } finally {
          this.submitting = false
        }
      })
      .catch(() => {
        // 校验失败，自动显示错误提示
      });
  }

  // async getCompanyCodeFn() {
  //   const { data } = await getCompanyCode({
  //     companyCode: this.form.goodsName,
  //   });
  //   this.form.memoryCode = data;
  // }

  confirmStoreCategory(data: any, indexList: any) {
    // this.form.offlineCategoryId =
    //   this.columns[indexList[0]].children[indexList[1]].children[
    //     indexList[2]
    //   ].categoryId;
    if (!indexList[1]) {
      this.form.offlineCategoryId = this.columns[indexList[0]].categoryId;
      this.form.offlineCategoryName = this.columns[indexList[0]].categoryName;
    } else if (!indexList[2]) {
      this.form.offlineCategoryId =
        this.columns[indexList[0]].children[indexList[1]].categoryId;
      this.form.offlineCategoryName =
        this.columns[indexList[0]].children[indexList[1]].categoryName;
    } else {
      this.form.offlineCategoryId =
        this.columns[indexList[0]].children[indexList[1]].children[
          indexList[2]
        ].categoryId;
      this.form.offlineCategoryName =
        this.columns[indexList[0]].children[indexList[1]].children[
          indexList[2]
        ].categoryName;
    }

    this.showStoreCategoryPicker = false;
  }

  async getGoodsUnitListFn() {
    const { data } = await getGoodsUnitList({
      storeId: this.companyId,
      pageIndex: 1,
      pageSize: 9999,
    });
    this.goodsUnitList = data.records;
  }

  confirmCategory(data: any, indexList: any) {
    this.form.categoryId =
      this.columnsCategory[indexList[0]].children[indexList[1]].categoryId;

    if (!indexList[1]) {
      this.form.categoryName = this.columnsCategory[indexList[0]].categoryName;
    } else {
      this.form.categoryName =
        this.columnsCategory[indexList[0]].children[indexList[1]].categoryName;
    }

    this.showCategoryPicker = false;
  }

  // 门店分类
  async getOfflineCategoryListFn() {
    const { data } = await getOfflineCategoryList({
      storeId: this.companyId,
      isTree: 1,
    });
    this.columns = this.transformCategoriesWithAll(data);
    console.log(this.columns, "////////");
  }
  // 微店分类
  async getIngredientCategoryListFn() {
    const { data } = await getIngredientCategoryList({
      storeId: this.companyId,
      isTree: 1,
    });
    // data.forEach((item) => {
    //   delete item.children;
    // });

    this.columnsCategory = this.transformCategoriesWithAll(
      data,
      1,
      "",
      false,
      2
    );
  }

  async getIngredientCategoryFn() {
    const { data } = await getIngredientCategory({
      storeId: this.companyId,
      ingredientId: this.form.ingredientId,
    });
    if (!data) return;
    this.form.categoryName = data.categoryName;
    this.form.categoryId = data.categoryId;
  }

  async getGoodsFileDtlFn() {
    const { data } = await getGoodsFileDtl({
      storeId: this.companyId,
      goodsId: this.goodsId,
    });
    if (data.ingredientName === '食材匹配不准确' || !data.ingredientId) {
      data.ingredientId = 'mismatch'
    }
    this.form = data;
    this.form.joinSellUnitWay = data.sellUnitWay
    this.defaultGoodsTypeIndex = this.productTypeList.findIndex(
      (i) => i.id === data.productType
    );
    this.form.productTypeName =
      this.productTypeList[this.defaultGoodsTypeIndex].name;

    this.defaultUnitIndex = this.goodsUnitList.findIndex(
      (i) => i.name === data.sellUnitWay
    );
    this.searchIngredientList() 
  }

  transformCategoriesWithAll(
    apiData: any[],
    level = 1,
    parentId?: string,
    isAllParent = false,
    totalLevel = 3
  ): any[] {
    const transformed = apiData.map((item) => {
      const node: any = {
        categoryName: item.categoryName,
        categoryId: item.categoryId,
      };

      // 有 children 且未到最大层级
      if (item.children && item.children.length > 0 && level < totalLevel) {
        if (level === 2 && item.categoryName === "全部") {
          node.children = [
            {
              categoryName: "全部",
              categoryId: item.categoryId,
            },
          ];
        } else {
          node.children = this.transformCategoriesWithAll(
            item.children,
            level + 1,
            item.categoryId,
            item.categoryName === "全部",
            totalLevel
          );
        }
      } else if (level === 1) {
        // 一级分类没有 children → 默认生成二级 "全部"
        node.children = [
          {
            categoryName: "全部",
            categoryId: item.categoryId,
          },
        ];
      } else if (level === 2 && item.categoryName !== "全部") {
        // 二级普通分类没有 children → 默认生成三级 "全部"
        node.children = [
          {
            categoryName: "全部",
            categoryId: node.categoryId,
          },
        ];
      }

      // 二级普通分类：确保 children 最前面有 "全部"
      if (level === 2 && node.categoryName !== "全部") {
        if (!node.children) node.children = [];
        if (!node.children.some((c) => c.categoryName === "全部")) {
          node.children.unshift({
            categoryName: "全部",
            categoryId: node.categoryId,
          });
        }
      }

      return node;
    });

    // 一级分类下面的二级，确保加 "全部"
    if (level === 2) {
      transformed.unshift({
        categoryName: "全部",
        categoryId: parentId,
        children:
          level < totalLevel
            ? [{ categoryName: "全部", categoryId: parentId }]
            : undefined,
      });
    }

    // 三级及以下：父级不是 "全部" 时，加 "全部"
    if (level > 2 && level <= totalLevel && !isAllParent) {
      if (!transformed.some((c) => c.categoryName === "全部")) {
        transformed.unshift({
          categoryName: "全部",
          categoryId: parentId,
        });
      }
    }

    return transformed;
  }

  onConfirmUnit(item: any) {
    this.form.sellUnitWay = item.name;
    this.form.joinSellUnitWay = item.name;
    this.form.unitId = item.autoId;
    this.showUnit = false;
  }

  onConfirmGoodsType(item: any) {
    this.form.productType = item.id;
    this.form.productTypeName = item.name;
    this.showGoodsType = false;
    if (item.id === 2) {
      this.goodsUnitList.map((item: any) => {
        if (item.name === "Kg" || item.name === "kg") {
          this.form.unitId = item.name;
          this.form.sellUnitWay = this.form.unitId;
          this.form.joinSellUnitWay = this.form.unitId;
        }
      });
    } else {
      this.form.unitId = "";
      this.form.sellUnitWay = "";
      this.form.joinSellUnitWay = ""
    }
  }
  handleCategoryName() {
    if ((this.form.ingredientId && this.form.ingredientId !== 'mismatch') || !this.form.isStoreProduct) return;
    this.showCategoryPicker = true;
  }

  afterRead() {
    const data = {
      fileType: "1",
      maxFileCount: "7",
    };
    sftpChooseFile(data).then((res: any) => {
      res.map((item: { [x: string]: any }) => {
        if (this.form.storeImageList.length < 7) { // 限制用户上传图片数量为7张 超出7张的不push
          this.form.storeImageList.push({
            imageUrl: item.filePath,
            // imageBase64Url: downloadUrl(item.filePath),
            // imageSize: item.fileSize
          });
        }
      });
    });
  }
  delImg(index: number) {
    this.form.storeImageList.splice(index, 1);
  }

  handleShowUnit() {
    if (this.form.productType === 2) return;
    this.showUnit = true;
  }
}
